import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { compose } from 'redux';
import { withTranslation } from '../../src/i18n';
import Artists from '../../containers/Artists';
import reducer, { key } from '../../containers/Artists/reducer';
import { getArtistsAction } from '../../containers/Artists/actions';
import { ARTIST_TYPE_ID, PROFESSIONS_AVAILABILITY, TP } from '../../constants/consts';
import { getArtistProfessionsAction, getList, getArtistVoiceTypesAction } from '../../containers/App/actions';
import { removeWithTranslationProps } from '../../utils/common';
import getInjectors from '../../store/reducerInjectors';
import { useInjectReducer } from '../../store/injectReducer';
import { PROFESSION_QUALIFICATIONS_ENDPOINT } from '../../constants/endpointConstants';
import route from '../../constants/routes';

const ArtistsPage = ({ t, query, isPresentationMode }) => {
  useInjectReducer([{ key, reducer }]);
  const customBreadcrumbs = [
    { path: route.HOME, title: `${TP}.m_HOME` },
    { path: route.ARTISTS, title: `${TP}.m_ARTISTS` },
  ];
  return (
    <Artists
      t={t}
      querySearchOptions={query}
      isPresentationMode={isPresentationMode}
      customBreadcrumbs={customBreadcrumbs}
    />
  );
};

ArtistsPage.getInitialProps = async ctx => {
  const { store, query } = ctx;
  getInjectors(store).injectReducer([{ key, reducer }]);
  let filters = { tier: 'A', sort: 'random' };
  let isPresentationMode = true;
  const strippedQuery = removeWithTranslationProps(query);
  const professionsList = get(store.getState().App, 'artistProfessions', []);
  const voicesList = get(store.getState().App, 'voiceTypes.data', []);

  if (Object.keys(strippedQuery).length > 0) {
    filters = strippedQuery;
    isPresentationMode = false;
  }
  store.dispatch(
    getArtistsAction({
      type: ARTIST_TYPE_ID,
      pagination: { limit: 24, page: 1 },
      filters,
    }),
  );
  if (professionsList.length === 0) {
    store.dispatch(getArtistProfessionsAction({ query: { availability: PROFESSIONS_AVAILABILITY.GET_PROFILE } }));
  }
  if (voicesList.length === 0) {
    store.dispatch(
      getList({
        endpoint: PROFESSION_QUALIFICATIONS_ENDPOINT,
        sagaRoutine: getArtistVoiceTypesAction,
        params: { queryParams: { availability: PROFESSIONS_AVAILABILITY.GET_PROFILE }, pagination: { limit: 100 } },
      }),
    );
  }
  return {
    namespacesRequired: ['translation'],
    query: filters,
    isPresentationMode,
  };
};

ArtistsPage.propTypes = {
  t: PropTypes.func.isRequired,
};

export default compose(withTranslation('translation'))(ArtistsPage);
